export enum TimeSlot {
  Morning = 'MORNING',
  Afternoon = 'AFTERNOON',
  Night = 'NIGHT',
}
